import React from 'react';
import { ColumnDefinition } from './types';
import cls from 'classnames';
import './table.module.scss';
import { Loader } from '../../../../mainv3/components/atoms/forms/loader';

export function TableHeader<R>({ columns }: Props<R>) {
  return (
    <thead styleName="table-header">
      {columns.map((column, index) => (
        <th key={column.id || index}>{column.label}</th>
      ))}
    </thead>
  );
}

type RowProps<R> = {
  rowKey: string;
  classNames: string[];
  record: R;
  columns: ColumnDefinition<R>[];
};

export function TableRow<R>({ rowKey, columns, record, classNames }: RowProps<R>) {
  return (
    <tr styleName="table-row" data-row-key={rowKey} className={cls('table-row', ...classNames)}>
      {columns.map((column, index) => {
        const props = column.props ? column.props(record) : {};
        // rowSpan/colSpanが0の場合はセルを定義しない
        if (props['rowSpan'] === 0 || props['colSpan'] === 0) {
          return null;
        }
        return (
          <td key={column.id || index} {...props}>
            {column.render(record)}
          </td>
        );
      })}
    </tr>
  );
}

export function TableBody<R>({ rowKey, columns, rowClassNames, data }: Props<R>) {
  return (
    <tbody styleName="table-body">
      {data.map((record, index) => {
        const key = rowKey ? String(rowKey(record)) : String(index);
        const classNames = rowClassNames ? rowClassNames(record, index) : [];
        return <TableRow key={key} rowKey={key} columns={columns} record={record} classNames={classNames} />;
      })}
    </tbody>
  );
}

type Props<R> = {
  id?: string;
  rowKey?: (record: R) => string | number;
  rowClassNames?: (record: R, index: number) => string[];
  columns: ColumnDefinition<R>[];
  data: R[];
  loading?: boolean;
};

export function Table<R>(props: Props<R>) {
  return (
    <table id={props.id} styleName="table">
      <TableHeader {...props} />
      <TableBody {...props} />
      {props.loading && (
        <div styleName="overlay">
          <Loader styleName="loader" />
        </div>
      )}
    </table>
  );
}
